import Environment from '../../Environment';
import BaseService, { IHttpResponse, IUri } from '../BaseService';

export interface IUserProfileInfo {
  customProfileHeaderUrl?: string;
  email?: string;
  firstName?: string;
  image?: string;
  initials?: string;
  lastName?: string;
  profileID?: string;
  userID: string;
  fullName?: string;
}

interface IGetUserProfile extends IUri {
  appKey: string;
  token: string;
  getFromCache?: boolean;
}

export interface IUserProfileFeedResponse extends IHttpResponse {
  body?: IUserProfileInfo;
}

export default async function ({
  appKey,
  token,
  getFromCache = true,
}: IGetUserProfile): Promise<IUserProfileFeedResponse> {
  const url = `${Environment.feedsService}/profile/${appKey}/user-info`;

  return BaseService.Get({
    token,
    url,
    getFromCache,
  });
}
